module.exports = __webpack_public_path__ + "static/media/alerte_orange_sans_point.1f414beb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/apps/tunnel/components/@sharded/notifications/alerte_orange_sans_point.svg
// module id = 545
// module chunks = 0